import Vue from "vue";
import Router from "vue-router";

import platformaMieszkaniowa from "@/components/leads/platformaMieszkaniowa";
import narrowTemplate from "@/components/partials/misc/narrowTemplate";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: narrowTemplate,
      children: [{ path: "/", component: platformaMieszkaniowa }],
    },
  ],
});
